import { Link } from "react-router-dom";
import tubingImage from "@/assets/tubing-group-friends.webp";
import { Button } from "@/components/ui/button";

const FinalCTASection = () => {
  return (
    <section className="relative py-32 overflow-hidden min-h-[600px]">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={tubingImage}
          alt="Friends enjoying tubing on the San Marcos River at Son's Blue River Camp"
          className="w-full h-full object-cover"
          loading="lazy"
          decoding="async"
          width={1920}
          height={600}
        />
      </div>

      {/* Headline at top */}
      <div className="relative container mx-auto px-4 text-center pt-8">
        <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl font-bold text-cream">
          Ready to Make Some Memories?
        </h2>
      </div>

      {/* Text and button absolutely positioned at bottom */}
      <div className="absolute bottom-8 left-0 right-0 container mx-auto px-4 text-center">
        <div className="flex flex-col items-center gap-6">
          <p className="text-2xl md:text-3xl font-bold text-cream/90 max-w-2xl mx-auto [text-shadow:_-1px_-1px_0_#000,_1px_-1px_0_#000,_-1px_1px_0_#000,_1px_1px_0_#000]">
            Your family's perfect river getaway is waiting.
          </p>
          <Button variant="cta" asChild size="lg" className="text-lg px-8 py-6">
            <Link to="/book-now">Book Now</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
